var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "story-maker-sticker story-maker-sticker-image" },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c("p", { staticClass: "text-finish" }, [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.done"))),
      ]),
      _c("div", { staticClass: "sticker-image" }, [
        _c("img", {
          staticClass: "selectDisable",
          attrs: {
            "data-check-load": "",
            draggable: "false",
            src: _vm.stickerInstance.imageUrl,
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }